import * as React from 'react';
import { Heading, Button, Modal, VStack, Text } from 'native-base';
import { FormControl } from 'native-base';
import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks';
import { InputWithLabel } from '../Form/InputWithLabel';
import { SelectWithLabel } from '../Form/SelectWithLabel';
import { Loader } from '../Loader';
import { GENDERS } from '../OnboardingForm/PersonalInfo/Gender';
import { ETHNICITIES } from '../OnboardingForm/PersonalInfo/Identify';
import { locationOptions } from '../../data/locationOptions';

const GENDER_OPTIONS = GENDERS.map((gender) => ({
  label: gender,
  value: gender,
}));

const ETHNICITIES_OPTIONS = ETHNICITIES.map((gender) => ({
  label: gender,
  value: gender,
}));

export const PersonalInfo = () => {
  const { loading, user } = useAuth();
  const [modalVisible, setModalVisible] = useState(false);
  const initialFormData = {
    firstName: user?.first_name,
    lastName: user?.last_name,
    email: user?.email,
    phoneNumber: user?.phone_number,
    state: user?.address_state,
    gender: user?.gender,
    birthdate: user?.birthdate,
    ethnicity: user?.ethnicity,
  };
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (user?.email && !formData) {
      setFormData(initialFormData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) return <Loader loading={loading} />;

  const InfoModal = () => {
    return (
      <Modal
        isOpen={modalVisible}
        onClose={setModalVisible}
        size={'lg'}
        _backdrop={{
          bg: 'black',
          opacity: '.75',
        }}
      >
        <Modal.Content maxH="600">
          <Modal.CloseButton />
          <Modal.Header>
            <Heading w={'80%'} fontSize={'xl'}>
              How do I change this?
            </Heading>
          </Modal.Header>
          <Modal.Body>
            <Text fontSize={'md'} fontWeight={'normal'}>
              Due to healthcare regulations, your primary residence must be in a
              participating state for you to use Ayble. Please contact us to
              change your state.
            </Text>
            <Button
              w={'100%'}
              mt={5}
              onPress={() => {
                setModalVisible(false);
              }}
            >
              Got It!
            </Button>
          </Modal.Body>
        </Modal.Content>
      </Modal>
    );
  };

  return (
    formData && (
      <>
        <VStack w={'100%'} mt={2}>
          <FormControl>
            <InputWithLabel
              label="First Name"
              onChange={(firstName) => {
                setFormData({ ...formData, firstName });
              }}
              value={formData.firstName}
            />
            <InputWithLabel
              label="Last Name"
              onChange={(lastName) => {
                setFormData({ ...formData, lastName });
              }}
              value={formData.lastName}
            />
            <InputWithLabel
              isReadOnly={true}
              label="Email"
              value={formData.email}
            />
            <InputWithLabel
              label="Phone Number"
              onChange={(phoneNumber) => {
                setFormData({ ...formData, phoneNumber });
              }}
              placeholder="Insert a phone number"
              type="tel"
              value={formData.phoneNumber}
            />
            <SelectWithLabel
              isDisabled={true}
              label="State"
              onChange={(selectedOption) => {
                setFormData({ ...formData, state: selectedOption.value });
              }}
              options={locationOptions}
              placeholder="Select an option"
              value={locationOptions
                .flatMap((data) => data.options)
                .find((state) => state.value === formData.state)}
            />
            <SelectWithLabel
              isSearchable={false}
              label="Gender"
              onChange={(selectedOption) => {
                setFormData({ ...formData, state: selectedOption.value });
              }}
              options={GENDER_OPTIONS}
              placeholder="Select an option"
              value={GENDER_OPTIONS.find(
                (opt) => opt.value === formData.gender
              )}
            />
            <InputWithLabel
              label="Birthdate"
              min="1900-01-01"
              max="2050-12-31"
              onChange={(birthdate) => {
                setFormData({ ...formData, birthdate });
              }}
              type="date"
              value={formData.birthdate}
            />
            <SelectWithLabel
              label="Ethnicity"
              menuPlacement="top"
              onChange={(selectedOption) => {
                setFormData({ ...formData, state: selectedOption.value });
              }}
              options={ETHNICITIES_OPTIONS}
              placeholder="Select an option"
              value={ETHNICITIES_OPTIONS.find(
                (e) => e.value === formData.ethnicity
              )}
            />
          </FormControl>
          <Button
            mt={8}
            onPress={() => null}
            size="sm"
            type="button"
            w={'128px'}
          >
            Save
          </Button>
        </VStack>
        <InfoModal />
      </>
    )
  );
};
